export default __webpack_public_path__ + "static/media/send-message.1fcc4bdc.svg";